import React from 'react';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '@/common/SafeIcon';

const {FaFacebookF,FaInstagram,FaAt}=FaIcons;

const socialLinks=[
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/profile.php?id=61578745554661',
    icon: FaFacebookF,
    color: 'hover:text-blue-600',
    bgColor: 'hover:bg-blue-50'
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/homy.hk',
    icon: FaInstagram,
    color: 'hover:text-pink-600',
    bgColor: 'hover:bg-pink-50'
  },
  {
    name: 'Threads',
    url: 'https://www.threads.com/@homy.hk',
    icon: FaAt,
    color: 'hover:text-gray-800',
    bgColor: 'hover:bg-gray-100'
  }
];

const SocialLinks=()=> (
  <div
    className="flex items-center justify-center gap-2"
    aria-label="Homy Tech Limited 社群網站"
  >
    {socialLinks.map((social)=> (
      <a
        key={social.name}
        href={social.url}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex h-7 w-7 items-center justify-center rounded-full border border-gray-200/50 bg-white/80 text-gray-600 shadow-sm backdrop-blur-sm transition-all duration-300 hover:scale-110 hover:shadow-md active:scale-95 ${social.color} ${social.bgColor}`}
        aria-label={`前往 Homy Tech Limited 的 ${social.name}`}
      >
        <SafeIcon icon={social.icon} className="text-xs" />
      </a>
    ))}
  </div>
);

const Footer=()=> (
  <footer
    className="fixed bottom-0 left-0 right-0 z-[5] bg-gradient-to-t from-[#fff9e9]/95 to-transparent py-2 backdrop-blur-sm lg:py-3"
    aria-label="關於萌趣方塊 2048 與聯絡資料"
  >
    <div className="mx-auto flex max-w-7xl items-end justify-center gap-4 px-4 text-center lg:gap-6">
      <section
        id="about"
        className="max-w-sm"
        aria-labelledby="about-heading"
        itemScope
        itemType="https://schema.org/AboutPage"
      >
        <h2
          id="about-heading"
          className="mb-0.5 text-[10px] font-black text-gray-600 lg:text-xs"
          itemProp="name"
        >
          誰製作了萌趣方塊 2048?
        </h2>
        <p
          className="text-[8px] font-medium leading-tight text-gray-500 lg:text-[10px]"
          itemProp="description"
        >
          由香港{' '}
          <a
            href="https://homy.hk/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-gray-600 transition-colors hover:text-[#ff7e5f]"
            itemProp="url"
          >
            <span itemProp="creator">Homy Tech Limited</span>
          </a>
          {' '}設計及開發。
        </p>
      </section>

      <span
        className="mb-1 hidden h-7 w-px bg-gray-300/60 sm:block"
        aria-hidden="true"
      />

      <section
        id="contact"
        className="max-w-sm"
        aria-labelledby="contact-heading"
        itemScope
        itemType="https://schema.org/ContactPage"
      >
        <h2
          id="contact-heading"
          className="mb-0.5 text-[10px] font-black text-gray-600 lg:text-xs"
          itemProp="name"
        >
          如何聯絡遊戲製作團隊?
        </h2>
        <address className="not-italic text-[8px] font-medium leading-tight text-gray-500 lg:text-[10px]">
          <a
            href="mailto:hello@homy.hk?subject=萌趣方塊 2048 查詢"
            className="font-bold text-[#e86f53] transition-colors hover:text-[#c9543c]"
            itemProp="email"
          >
            hello@homy.hk
          </a>
        </address>
      </section>

      <SocialLinks />
    </div>
  </footer>
);

export default Footer;